import React, { useState, useRef, useEffect } from "react";
import bgImage from './analytics3.jpg';
import MainPopup from "../popup-containers/MainPopup";
import InvitePartnerPopup from "../popup-containers/InvitePartnerPopup";
import PopUpScreenTitle from '../components/PopUpScreenTitle';
import PopUpButtons from "../components/PopUpButtons";
import toast from "react-hot-toast";
import { IUDAPI } from "../services/APIConnection";

const Firstpage = () => {
  const [demoVideoPopup, setDemoVideoPopup] = useState(false);
  const [invitePartnerPopup, setInvitePartnerPopup] = useState(false);
  const invitePartnerRef = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenDemoVideo = () => {
    setDemoVideoPopup(true);
  };

  const handleCloseDemoVideo = () => {
    setDemoVideoPopup(false);
  };
  const handleInvitePartner = () => {
    setInvitePartnerPopup(true);
  };
  const handleCloseInvitePartner = () => {
    if (invitePartnerRef.current) {
      invitePartnerRef.current.clearFormData();
    }
    setInvitePartnerPopup(false);
    setIsLoading(false);
  };


  const handleSubmitInvitePartner = async () => {
    const formData = invitePartnerRef.current.validateAndGetFormData();
    if (formData.success) {

      setIsLoading(true);

      const payload = {
        ValueChainPartner: formData.data.VCPartner,
        VCPFirstName: formData.data.VCPContPersonFirstName,
        VCPLastName: formData.data.VCPContPersonLastName,
        VCPPosition: formData.data.VCPContPersonPosition,
        VCPEmail: formData.data.VCPContPersonEmail,
        VCPMobile: formData.data.VCPContPersonMobile,
        Company: formData.data.company,
        CFirstName: formData.data.companyInvPersonFirstName,
        CLastName: formData.data.companyInvPersonLastName,
        CPosition: formData.data.companyInvPersonPosition,
        CEmail: formData.data.companyInvPersonEmail,
        CMobile: formData.data.companyInvPersonMobile,
      };
      const response = await IUDAPI(payload, "PartnerAPI/IUDInvitePartner");
      if (response.data.Table[0].Result === "S") {
        toast.success("Mail send successfully 👍", {
          duration: 2000,
          position: "top-center",
        });

        setTimeout(handleCloseInvitePartner, 2000);
      } else {
        toast.error("Failed to send mail 👎", {
          duration: 2000,
          position: "top-center",
        });
        setTimeout(handleCloseInvitePartner, 2000);
      }
    }
  };
  return (
    <section
      className="relative bg-cover bg-center  flex items-center  min-h-screen justify-center"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      <div className="relative z-10 px-4 sm:px-8 max-w-6xl w-full text-center md:text-left text-white">
        <h1 className="text-xl sm:text-2xl mb-2 md:text-4xl lg:text-5xl font-bold leading-tight md:mb-6 drop-shadow-xl">
          Ethosflo - Assess ESG Maturity of <br className="hidden md:block" />
          your Value Chain quickly, credibly and aligned with global regulations
        </h1>

        <p className="text-sm sm:text-base md:text-lg lg:text-2xl text-white/90 mb-8 max-w-5xl mx-auto md:mx-0 text-justify drop-shadow-md leading-relaxed">
          Ethosflo is a low-cost, on-demand, value chain sustainability maturity assessment platform that allows organizations assess various environmental, social, and governance (ESG) aspects of their business partners (suppliers, customers, portfolio) and manage risks in their business.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full">
          <button
            className="text-lg px-4 py-2 bg-[#0A988B] hover:bg-teal-400 text-white font-semibold rounded transition duration-300 w-full sm:w-auto"
            onClick={handleOpenDemoVideo}
          >
            Demo
          </button>
          <button
            className="text-lg px-4 py-2 bg-[#0A988B] hover:bg-teal-400 text-white font-semibold rounded transition duration-300 w-full sm:w-auto"
            onClick={(e) => {
              e.preventDefault();
              handleInvitePartner();
            }}
          >
            Invite Your Partners
          </button>
        </div>
      </div>

      {demoVideoPopup && (
        <MainPopup popUpOpen={demoVideoPopup} setpopUpOpen={setDemoVideoPopup}
          bgcolor={true}
          loginPopups={true}
          widthAdjustment={true}>
          <div>
            <PopUpScreenTitle
              title="Demo Video"
              setpopUpOpen={handleCloseDemoVideo}
              hederDetails={true}
              titleColorstatus={true}


            />
            <div className="aspect-video w-3/4 pb-6 max-w-3xl mx-auto">
              <iframe className="w-full h-full rounded-lg shadow-lg" src="https://www.youtube.com/embed/WU-kwa76qG0?si=XLobfcIqBRBa1Sz8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            {/* <div className=" p-4 lg:mx-4  rounded-md shadow-sm">
          <div className="mb-2 text-sm text-green-400 italic flex justify-center">
            The demo video is under progress. You can see the video when it's ready.
          </div>
        </div> */}
          </div>
        </MainPopup>
      )}

      <MainPopup
        popUpOpen={invitePartnerPopup}
        setpopUpOpen={setInvitePartnerPopup}
        loginPopups={true}
        widthAdjustment={true}
      // bgcolor={true}
      >

        <div>
          <PopUpScreenTitle
            title="Invite Your Partners"
            setpopUpOpen={setInvitePartnerPopup}
            hederDetails={true}
          // titleColorstatus={true}
          />
          {/* <InvitePartnerPopup closePopup={handleCloseInvitePartner} /> */}
          <InvitePartnerPopup
            ref={invitePartnerRef}
            closePopup={handleCloseInvitePartner}
            isLoading={isLoading}
          />
        </div>
        <PopUpButtons
          buttonLabel="Send Mail"
          submitDetails={true}
          handleSubmit={handleSubmitInvitePartner}

          cancel={handleCloseInvitePartner}
          disabledBtn={isLoading}
        />
      </MainPopup>
    </section>
  );
};

export default Firstpage;
